/* eslint-disable */
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  Textarea,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { forwardRef, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { securedAxiosInstance } from '../../api/axios';
import { saveLog, getVaults } from '../../stores/slices/vaults/vaultsActions';
import { Select as Multiselect } from 'chakra-react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './inlinedatepicker.css';
import {
  getReminders,
  saveReminder,
} from '../../stores/slices/reminders/remindersActions';
import { format, formatISO } from 'date-fns';
import { FaCaretDown } from 'react-icons/fa';
import moment from 'moment';

const ReminderModal = ({
  isOpen,
  onOpen,
  onClose,
  toUpdate,
  reminderType = 'reminder',
}) => {
  const CalendarCustomInput = forwardRef(({ value, onClick }, ref) => (
    <Button
      variant={'outline'}
      rightIcon={<FaCaretDown />}
      justifyContent={'space-between'}
      w={'full'}
      onClick={onClick}
      fontWeight={'normal'}
      ref={ref}
    >
      {value}
    </Button>
  ));
  const { userInfo } = useSelector(state => state.user);
  const schema = yup
    .object({
      reminder: yup.string().required('Reminder detail is required'),
      due: yup.string().required('Due date is required'),
      dueTime: yup.string().required('Due time is required'),
    })
    .required();

  const dispatch = useDispatch();
  const toast = useToast();

  const [users, setUsers] = useState([]);
  useEffect(() => {
    const getUsers = async () => {
      const res = await securedAxiosInstance.get(`/users`);
      setUsers(
        res.data.map(data => {
          return {
            label: data.email,
            full_name: data.full_name,
            value: data.id,
          };
        })
      );
      return;
    };

    getUsers();
  }, []);
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      repeatNum: 1,
      dueTime: new Date(),
      reminderType,
    },
  });
  const watchRepeatUnit = watch('repeatUnit', 'norepeat');
  useEffect(() => {
    if (toUpdate.state) {
      reset({
        userSelect: users.filter(user => {
          return toUpdate.reminder.users.find(toUpdateUser => {
            return toUpdateUser.id === user.value;
          });
        }),
        repeatUnit: toUpdate.reminder.repeat_unit,
        due: format(new Date(toUpdate.reminder.due), 'yyyy-MM-dd'),
        dueTime: moment
          .utc(new Date(toUpdate.reminder.due_time))
          .format('HH:mm'),
        reminderType: toUpdate.reminder.reminder_type || 'reminder',
      });
    }
  }, [users, toUpdate]);

  const onSave = async data => {
    const res = await dispatch(
      saveReminder({
        reminderDetail: data.reminder,
        userId: userInfo.id,
        due: new Date(data.due).toISOString(),
        dueTime: data.dueTime,
        description: data.description,
        repeatNum: data.repeatNum,
        repeatUnit: data.repeatUnit,
        userSelect: data.userSelect,
        reminderType: data.reminderType,
        isUpdate: toUpdate,
      })
    );

    if (res.type === 'reminders/saveReminder/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      reset();
      onClose();
      dispatch(getReminders());
      toast({
        description: toUpdate.state
          ? 'Reminder has been updated'
          : 'Reminder has been created',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={() => {
        reset();
        onClose();
      }}
    >
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit(onSave)}>
          <ModalHeader>
            {toUpdate.state ? 'Edit' : 'Add new'} reminder
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <VStack spacing={'2'}>
              <Controller
                control={control}
                name="userSelect"
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <FormControl isInvalid={!!error} id="userSelect">
                    <FormLabel>Employee</FormLabel>
                    <Multiselect
                      isMulti
                      name={name}
                      ref={ref}
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      options={users}
                      placeholder="Select employee"
                      isClearable
                      closeMenuOnSelect
                      className="chakra-react-select"
                      classNamePrefix="chakra-react-select"
                      selectedOptionStyle="check"
                      chakraStyles={{
                        dropdownIndicator: provided => ({
                          ...provided,
                          bg: 'transparent',
                          px: 2,
                          cursor: 'inherit',
                        }),
                        indicatorSeparator: provided => ({
                          ...provided,
                          display: 'none',
                        }),
                      }}
                    />

                    <FormErrorMessage>
                      {error && error.message}
                    </FormErrorMessage>
                  </FormControl>
                )}
              />
              <FormControl id="due" isInvalid={errors.due}>
                <FormLabel>Due date</FormLabel>
                <Input type={'date'} id="due" {...register('due')} />
                <FormErrorMessage>
                  {errors.due && errors.due.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="dueTime" isInvalid={errors.dueTime}>
                <FormLabel>Due time</FormLabel>
                <Input type={'time'} id="dueTime" {...register('dueTime')} />
                <FormErrorMessage>
                  {errors.dueTime && errors.dueTime.message}
                </FormErrorMessage>
              </FormControl>
              {/* <Controller
                name={'dueTime'}
                control={control}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <FormControl id="due" isInvalid={errors.due}>
                    <FormLabel>Due time</FormLabel>
                    <DatePicker
                      ref={ref}
                      name={name}
                      selected={value}
                      onChange={onChange}
                      showTimeSelectOnly
                      // dateFormat="dd/MM/yyyy h:mm aa"
                      wrapperClassName="fullwidth"
                      customInput={<CalendarCustomInput />}
                    />
                    <FormErrorMessage>
                      {errors.due && errors.due.message}
                    </FormErrorMessage>
                  </FormControl>
                )}
              /> */}
              <FormControl id="repeatUnit" isInvalid={errors.repeatUnit}>
                <FormLabel>Repeat</FormLabel>
                <HStack>
                  {watchRepeatUnit != 'norepeat' && (
                    <NumberInput
                      min={1}
                      id="repeatNum"
                      {...register('repeatNum')}
                      defaultValue={
                        toUpdate.state ? toUpdate.reminder.repeat_num : '1'
                      }
                    >
                      <NumberInputField />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                  )}
                  <Select
                    placeholder="Select option"
                    id="repeatUnit"
                    {...register('repeatUnit')}
                    defaultValue={
                      toUpdate.state
                        ? toUpdate.reminder.repeat_unit
                        : 'norepeat'
                    }
                  >
                    <option value="norepeat">None</option>
                    <option value="days">Days</option>
                    <option value="weeks">Weeks</option>
                    <option value="months">months</option>
                  </Select>
                </HStack>
                <FormErrorMessage>
                  {errors.repeatUnit && errors.repeatUnit.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="reminder" isInvalid={errors.reminder}>
                <FormLabel>Reminder title</FormLabel>
                <Input
                  id="reminder"
                  {...register('reminder')}
                  defaultValue={
                    toUpdate.state ? toUpdate.reminder.reminder : ''
                  }
                />
                <FormErrorMessage>
                  {errors.reminder && errors.reminder.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="description" isInvalid={errors.description}>
                <FormLabel>Description</FormLabel>
                <Textarea
                  id="description"
                  {...register('description')}
                  defaultValue={
                    toUpdate.state ? toUpdate.reminder.description : ''
                  }
                />
                <FormErrorMessage>
                  {errors.description && errors.description.message}
                </FormErrorMessage>
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} type="submit" isLoading={isSubmitting}>
              Save
            </Button>
            <Button
              onClick={() => {
                reset();
                onClose();
              }}
              variant="outline"
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default ReminderModal;
